// extracted by mini-css-extract-plugin
export default {"base":"ModalPopupSubs_base__00Ng6","card":"ModalPopupSubs_card__LYKcB"};